import styled from 'styled-components';

export const StyledModalContent = styled.div`
  padding: 8px 0;
`;

export const StyledLogDetails = styled.p`
  font-size: 14px;
  color: #1a1a1a;
  margin-bottom: 8px;
  line-height: 1.6;
`;

export const StyledUpdatedDate = styled.p`
  font-size: 12px;
  color: #666666;
  margin-bottom: 24px;
`;

export const StyledChangesSection = styled.div`
  background: #e6f4f1;
  border-radius: 8px;
  padding: 16px;
`;

export const StyledChangeItem = styled.div`
  font-size: 14px;
  color: #1a1a1a;
  line-height: 1.8;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  .value-tag {
    display: inline-block;
    padding: 2px 9px;
    background: #fafafa;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    font-weight: 500;
    margin: 0 2px;
  }
`;
